export const basicAlertSubTitle = [{ text: 'Print the basic message.' }];

export const titleWithTextSubTitle = [{ text: 'Print the title with text.' }];

export const infoAlertSubTitle = [{ text: 'Print the informational message.' }]

export const warningAlertSubTitle = [{ text: 'Warning for imaginary files.' }];

export const pikachuAlertSubTitle = [{ text: 'catch the pokeball.' }];

export const questionAlertSubTitle = [{ text: 'Print the questionary and give answers.' }];

export const userNameAlertSubTitle = [{ text: 'Print the basic sweet-alert' }];

export const successMessageSubTitle = [
    {text: 'Print the success message.'}
];

export const dangerAlertSubTitle = [
    {text: 'Print the danger message.'}
];

export const warningModeSubTitle = [{ text: 'Print the warning message' }];

export const autoCloseAlertSubTitle = [{ text: 'A text message with an automatic timer' }];

export const movieAlertSubTitle = [{ text: 'Give the movie name & return value.' }]